/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Undertraining_FreshInputs */

const en_coach_undertraining_fresh = /** @type {(inputs: Coach_Undertraining_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You are well-rested, but your recent training load is significantly below your baseline. While you are ready to perform now, sustained underloading will erode your fitness. Consider adding volume.`)
};

const de_coach_undertraining_fresh = /** @type {(inputs: Coach_Undertraining_FreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du bist gut erholt, aber dein Umfang liegt deutlich unter deiner Grundlinie. Noch kannst du gut performen — hält das an, geht Fitness verloren. Versuch, den Umfang etwas hochzufahren.`)
};

/**
* | output |
* | --- |
* | "You are well-rested, but your recent training load is significantly below your baseline. While you are ready to perform now, sustained underloading will erod..." |
*
* @param {Coach_Undertraining_FreshInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const coach_undertraining_fresh = /** @type {((inputs?: Coach_Undertraining_FreshInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Undertraining_FreshInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_coach_undertraining_fresh(inputs)
	return de_coach_undertraining_fresh(inputs)
});